/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import ServicesRow from "../../B/PlannedServices/ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import { confirmation } from "../../../types/dropDownTypes"
import { Dropdown } from "primereact/dropdown"
import { Checkbox } from "primereact/checkbox"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const ServicesReceived5 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [servicesReceived5, setServicesReceived5] = useState(
    interview[INTERVIEW_SECTIONS.SERVICES_RECEIVED_5]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_5
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SERVICES_RECEIVED_5
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  
  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.SERVICES_RECEIVED_5,
      servicesReceived5
    )
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICESRECEIVED5_DATA, {
          GpraK2: servicesReceived5?.gpra_k_2,
          GpraK3: servicesReceived5?.gpra_k_3,
          GpraK4: servicesReceived5?.gpra_k_4,
          GpraK4a1: servicesReceived5?.gpra_k_4a1,
          GpraK4a2: servicesReceived5?.gpra_k_4a2,
          GpraK4a3: servicesReceived5?.gpra_k_4a3,
          GpraK4a4: servicesReceived5?.gpra_k_4a4,
          GpraK4a5: servicesReceived5?.gpra_k_4a5,
          GpraK4b: servicesReceived5?.gpra_k_4b,
          GpraK5: servicesReceived5?.gpra_k_5,
          GpraK5a1: servicesReceived5?.gpra_k_5a1,
          GpraK5a2: servicesReceived5?.gpra_k_5a2,
          GpraK5a3: servicesReceived5?.gpra_k_5a3,
          GpraK5a4: servicesReceived5?.gpra_k_5a4,
          GpraK5a5: servicesReceived5?.gpra_k_5a5,
          GpraK5b: servicesReceived5?.gpra_k_5b,
          GpraK6: servicesReceived5?.gpra_k_6,
          GpraK6a1: servicesReceived5?.gpra_k_6a1,
          GpraK6a2: servicesReceived5?.gpra_k_6a2,
          GpraK6a3: servicesReceived5?.gpra_k_6a3,
          GpraK6a4: servicesReceived5?.gpra_k_6a4,
          GpraK6a5: servicesReceived5?.gpra_k_6a5,
          GpraK6b: servicesReceived5?.gpra_k_6b,
          GpraK7: servicesReceived5?.gpra_k_7,
          GpraK7a1: servicesReceived5?.gpra_k_7a1,
          GpraK7a2: servicesReceived5?.gpra_k_7a2,
          GpraK7a3: servicesReceived5?.gpra_k_7a3,
          GpraK7a4: servicesReceived5?.gpra_k_7a4,
          GpraK7b: servicesReceived5?.gpra_k_7b,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraKId: servicesReceived5?.gpra_k_id,
          Additional: getAdditionalQuestions(servicesReceived5),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ servicesReceived5: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      servicesReceived5?.gpra_k_2 === undefined &&
      showQuestion(questions, "gpra_k_2")
    ) {
      errors.gpra_k_2 = errorMessages.requiredMessage
    }
    if (
      servicesReceived5?.gpra_k_3 === undefined &&
      showQuestion(questions, "gpra_k_3")
    ) {
      errors.gpra_k_3 = errorMessages.requiredMessage
    }
    if (
      servicesReceived5?.gpra_k_4 === undefined &&
      showQuestion(questions, "gpra_k_4")
    ) {
      errors.gpra_k_4 = errorMessages.requiredMessage
    } else if (
      servicesReceived5?.gpra_k_4 &&
      !servicesReceived5?.gpra_k_4a5 &&
      showQuestion(questions, "gpra_k_4")
    ) {
      if (
        (!servicesReceived5?.gpra_k_4a1 || servicesReceived5?.gpra_k_4a1 < 0) &&
        (!servicesReceived5?.gpra_k_4a2 || servicesReceived5?.gpra_k_4a2 < 0) &&
        (!servicesReceived5?.gpra_k_4a3 || servicesReceived5?.gpra_k_4a3 < 0) &&
        (!servicesReceived5?.gpra_k_4a4 || servicesReceived5?.gpra_k_4a4 < 0)
      ) {
        errors.gpra_k_4a1 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_4a2 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_4a3 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_4a4 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_4a5 = errorMessages.mustSelectAtLeastOne
      }
      if (
        servicesReceived5?.gpra_k_4b === undefined &&
        showQuestion(questions, "gpra_k_4")
      ) {
        errors.gpra_k_4b = errorMessages.requiredMessage
      }
    }
    if (
      servicesReceived5?.gpra_k_5 === undefined &&
      showQuestion(questions, "gpra_k_5")
    ) {
      errors.gpra_k_5 = errorMessages.requiredMessage
    } else if (
      servicesReceived5?.gpra_k_5 &&
      !servicesReceived5?.gpra_k_5a5 &&
      showQuestion(questions, "gpra_k_5")
    ) {
      if (
        (!servicesReceived5?.gpra_k_5a1 || servicesReceived5?.gpra_k_5a1 < 0) &&
        (!servicesReceived5?.gpra_k_5a2 || servicesReceived5?.gpra_k_5a2 < 0) &&
        (!servicesReceived5?.gpra_k_5a3 || servicesReceived5?.gpra_k_5a3 < 0) &&
        (!servicesReceived5?.gpra_k_5a4 || servicesReceived5?.gpra_k_5a4 < 0)
      ) {
        errors.gpra_k_5a1 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_5a2 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_5a3 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_5a4 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_5a5 = errorMessages.mustSelectAtLeastOne
      }
      if (
        servicesReceived5?.gpra_k_5b === undefined &&
        showQuestion(questions, "gpra_k_5")
      ) {
        errors.gpra_k_5b = errorMessages.requiredMessage
      }
    }
    if (
      servicesReceived5?.gpra_k_6 === undefined &&
      showQuestion(questions, "gpra_k_6")
    ) {
      errors.gpra_k_6 = errorMessages.requiredMessage
    } else if (
      servicesReceived5?.gpra_k_6 &&
      !servicesReceived5?.gpra_k_6a5 &&
      showQuestion(questions, "gpra_k_6")
    ) {
      if (
        (!servicesReceived5?.gpra_k_6a1 || servicesReceived5?.gpra_k_6a1 < 0) &&
        (!servicesReceived5?.gpra_k_6a2 || servicesReceived5?.gpra_k_6a2 < 0) &&
        (!servicesReceived5?.gpra_k_6a3 || servicesReceived5?.gpra_k_6a3 < 0) &&
        (!servicesReceived5?.gpra_k_6a4 || servicesReceived5?.gpra_k_6a4 < 0)
      ) {
        errors.gpra_k_6a1 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_6a2 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_6a3 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_6a4 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_6a5 = errorMessages.mustSelectAtLeastOne
      }
      if (
        servicesReceived5?.gpra_k_6b === undefined &&
        showQuestion(questions, "gpra_k_6")
      ) {
        errors.gpra_k_6b = errorMessages.requiredMessage
      }
    }
    if (
      servicesReceived5?.gpra_k_7 === undefined &&
      showQuestion(questions, "gpra_k_7")
    ) {
      errors.gpra_k_7 = errorMessages.requiredMessage
    } else if (
      servicesReceived5?.gpra_k_7 &&
      !servicesReceived5?.gpra_k_7a4 &&
      showQuestion(questions, "gpra_k_7")
    ) {
      if (
        (!servicesReceived5?.gpra_k_7a1 || servicesReceived5?.gpra_k_7a1 < 0) &&
        (!servicesReceived5?.gpra_k_7a2 || servicesReceived5?.gpra_k_7a2 < 0) &&
        (!servicesReceived5?.gpra_k_7a3 || servicesReceived5?.gpra_k_7a3 < 0)
      ) {
        errors.gpra_k_7a1 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_7a2 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_7a3 = errorMessages.mustSelectAtLeastOne
        errors.gpra_k_7a4 = errorMessages.mustSelectAtLeastOne
      }
      if (
        servicesReceived5?.gpra_k_7b === undefined &&
        showQuestion(questions, "gpra_k_7")
      ) {
        errors.gpra_k_7b = errorMessages.requiredMessage
      }
    }

    setValidationErrors(
      validateQuestions(
        servicesReceived5,
        INTERVIEW_SECTIONS.SERVICES_RECEIVED_5,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_k_2") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Has this client attended 60% or more of their planned services?`}
            required
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_k_2
                ? gpraStyles.input2Error
                : gpraStyles.input2
            }
            value={servicesReceived5?.gpra_k_2}
            onChange={(e) => {
              updateState(
                "gpra_k_2",
                e.value,
                null,
                null,
                servicesReceived5,
                setServicesReceived5,
                null
              )
              removeError("gpra_k_2")
            }}
            options={confirmation}
            showClear={servicesReceived5?.gpra_k_2 !== undefined}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_k_2} />
        </div>
      )
    }
    if (question.field === "gpra_k_3") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Did this client receive any services via telehealth or a virtual platform?`}
            required
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_k_3
                ? gpraStyles.input2Error
                : gpraStyles.input2
            }
            value={servicesReceived5?.gpra_k_3}
            onChange={(e) => {
              updateState(
                "gpra_k_3",
                e.value,
                null,
                null,
                servicesReceived5,
                setServicesReceived5,
                null
              )
              removeError("gpra_k_3")
            }}
            options={confirmation}
            showClear={servicesReceived5?.gpra_k_3 !== undefined}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_k_3} />
        </div>
      )
    }
    if (question.field === "gpra_k_4") {  
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Has this client previously been diagnosed with an opioid use disorder?`}
              required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_k_4
                  ? gpraStyles.input2Error
                  : gpraStyles.input2
              }
              value={servicesReceived5?.gpra_k_4}
              onChange={(e) => {
                removeError("gpra_k_4")
                if (!e.value) {
                  updateState(
                    "gpra_k_4",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    [
                      { key: "gpra_k_4a1", value: 0 },
                      { key: "gpra_k_4a2", value: 0 },
                      { key: "gpra_k_4a3", value: 0 },
                      { key: "gpra_k_4a4", value: 0 },
                      { key: "gpra_k_4a5", value: false },
                      { key: "gpra_k_4b", value: false },
                    ]
                  )
                  removeError("gpra_k_4a1")
                  removeError("gpra_k_4a2")
                  removeError("gpra_k_4a3")
                  removeError("gpra_k_4a4")
                  removeError("gpra_k_4a5")
                  removeError("gpra_k_4b")
                } else {
                  updateState(
                    "gpra_k_4",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    null
                  )
                }
              }}
              options={confirmation}
              showClear={servicesReceived5?.gpra_k_4 !== undefined}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_k_4} errorType={2} />
          </div>
          {servicesReceived5?.gpra_k_4 && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "a. In the past 30 days, which FDA-approved medication did the client receive for the treatment of this opioid use disorder?"
                  } 
                  required
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="1. Methadone"
                  number={servicesReceived5?.gpra_k_4a1}
                  setNumber={"gpra_k_4a1"}
                  numberError={validationErrors.gpra_k_4a1}
                  numberErrorType="gpra_k_4a1"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_4 ||
                    servicesReceived5?.gpra_k_4a5
                  }
                  labelSize={"3"}
                  errorsToRemove={[
                    "gpra_k_4a1",
                    "gpra_k_4a2",
                    "gpra_k_4a3",
                    "gpra_k_4a4",
                    "gpra_k_4a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="2. Buprenorphine"
                  number={servicesReceived5?.gpra_k_4a2}
                  setNumber={"gpra_k_4a2"}
                  numberError={validationErrors.gpra_k_4a2}
                  numberErrorType="gpra_k_4a2"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_4 ||
                    servicesReceived5?.gpra_k_4a5
                  }
                  errorsToRemove={[
                    "gpra_k_4a1",
                    "gpra_k_4a2",
                    "gpra_k_4a3",
                    "gpra_k_4a4",
                    "gpra_k_4a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="3. Naltrexone"
                  number={servicesReceived5?.gpra_k_4a3}
                  setNumber={"gpra_k_4a3"}
                  numberError={validationErrors.gpra_k_4a3}
                  numberErrorType="gpra_k_4a3"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_4 ||
                    servicesReceived5?.gpra_k_4a5
                  }
                  errorsToRemove={[
                    "gpra_k_4a1",
                    "gpra_k_4a2",
                    "gpra_k_4a3",
                    "gpra_k_4a4",
                    "gpra_k_4a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="4. Extended‒release Naltrexone"
                  number={servicesReceived5?.gpra_k_4a4}
                  setNumber={"gpra_k_4a4"}
                  numberError={validationErrors.gpra_k_4a4}
                  numberErrorType="gpra_k_4a4"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_4 ||
                    servicesReceived5?.gpra_k_4a5
                  }
                  errorsToRemove={[
                    "gpra_k_4a1",
                    "gpra_k_4a2",
                    "gpra_k_4a3",
                    "gpra_k_4a4",
                    "gpra_k_4a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.serviceRow}>
                <div className={gpraStyles.checkbox}>
                  <Checkbox
                    inputId="binary"
                    checked={servicesReceived5?.gpra_k_4a5}
                    onChange={(e) => {
                      removeError("gpra_k_4a1")
                      removeError("gpra_k_4a2")
                      removeError("gpra_k_4a3")
                      removeError("gpra_k_4a4")
                      removeError("gpra_k_4a5")
                      if (e.checked) {
                        updateState(
                          "gpra_k_4a5",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          [
                            { key: "gpra_k_4a1", value: 0 },
                            { key: "gpra_k_4a2", value: 0 },
                            { key: "gpra_k_4a3", value: 0 },
                            { key: "gpra_k_4a4", value: 0 },
                          ]
                        )
                      } else {
                        updateState(
                          "gpra_k_4a5",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          null
                        )
                      }
                    }}
                    className={validationErrors.gpra_k_4a5 && "p-invalid"}
                    disabled={!servicesReceived5?.gpra_k_4}
                  />
                  <label className={gpraStyles.ml1} htmlFor="binary">
                    Client did not receive an FDA-approved medication for an
                    opioid use disorder
                  </label>
                </div>
                <FormError error={validationErrors.gpra_k_4a5} errorType={2} />
              </div>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "b. Has this client taken the medication as prescribed?"
                  }
                  required
                />
                <Dropdown
                  disabled={
                    disabled ||
                    servicesReceived5?.gpra_k_4a5 ||
                    !servicesReceived5?.gpra_k_4
                  }
                  className={
                    validationErrors.gpra_k_4b
                      ? gpraStyles.input2Error
                      : gpraStyles.input2
                  }
                  value={servicesReceived5?.gpra_k_4b}
                  onChange={(e) => {
                    updateState(
                      "gpra_k_4b",
                      e.value,
                      null,
                      null,
                      servicesReceived5,
                      setServicesReceived5,
                      null
                    )
                    removeError("gpra_k_4b")
                  }}
                  options={confirmation}
                  showClear={servicesReceived5?.gpra_k_4b !== undefined}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_k_4b} />
              </div>
            </>
          )}
        </>
      )
    }
    if (question.field === "gpra_k_5") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Has this client previously been diagnosed with an alcohol use disorder?`}
              required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_k_5
                  ? gpraStyles.input2Error
                  : gpraStyles.input2
              }
              value={servicesReceived5?.gpra_k_5}
              onChange={(e) => {
                removeError("gpra_k_5")
                if (!e.value) {
                  updateState(
                    "gpra_k_5",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    [
                      { key: "gpra_k_5a1", value: 0 },
                      { key: "gpra_k_5a2", value: 0 },
                      { key: "gpra_k_5a3", value: 0 },
                      { key: "gpra_k_5a4", value: 0 },
                      { key: "gpra_k_5a5", value: false },
                      { key: "gpra_k_5b", value: false },
                    ]
                  )
                  removeError("gpra_k_5a1")
                  removeError("gpra_k_5a2")
                  removeError("gpra_k_5a3")
                  removeError("gpra_k_5a4")
                  removeError("gpra_k_5a5")
                  removeError("gpra_k_5b")
                } else {
                  updateState(
                    "gpra_k_5",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    null
                  )
                }
              }}
              options={confirmation}
              showClear={servicesReceived5?.gpra_k_5 !== undefined}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_k_5} />
          </div>
          {servicesReceived5?.gpra_k_5 && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "a. In the past 30 days, which FDA-approved medication did the client receive for the treatment of this alcohol use disorder?"
                  }
                  required
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="1. Naltrexone"
                  number={servicesReceived5?.gpra_k_5a1}
                  setNumber={"gpra_k_5a1"}
                  numberError={validationErrors.gpra_k_5a1}
                  numberErrorType="gpra_k_5a1"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_5 ||
                    servicesReceived5?.gpra_k_5a5
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_5a1",
                    "gpra_k_5a2",
                    "gpra_k_5a3",
                    "gpra_k_5a4",
                    "gpra_k_5a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="2. Extended‒release Naltrexone"
                  number={servicesReceived5?.gpra_k_5a2}
                  setNumber={"gpra_k_5a2"}
                  numberError={validationErrors.gpra_k_5a2}
                  numberErrorType="gpra_k_5a2"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_5 ||
                    servicesReceived5?.gpra_k_5a5
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_5a1",
                    "gpra_k_5a2",
                    "gpra_k_5a3",
                    "gpra_k_5a4",
                    "gpra_k_5a5",
                  ]}
                  defaultZero={question.defaultZero}
                  s
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="3. Disulfiram"
                  number={servicesReceived5?.gpra_k_5a3}
                  setNumber={"gpra_k_5a3"}
                  numberError={validationErrors.gpra_k_5a3}
                  numberErrorType="gpra_k_5a3"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_5 ||
                    servicesReceived5?.gpra_k_5a5
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_5a1",
                    "gpra_k_5a2",
                    "gpra_k_5a3",
                    "gpra_k_5a4",
                    "gpra_k_5a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="4. Acamprosate"
                  number={servicesReceived5?.gpra_k_5a4}
                  setNumber={"gpra_k_5a4"}
                  numberError={validationErrors.gpra_k_5a4}
                  numberErrorType="gpra_k_5a4"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_5 ||
                    servicesReceived5?.gpra_k_5a5
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_5a1",
                    "gpra_k_5a2",
                    "gpra_k_5a3",
                    "gpra_k_5a4",
                    "gpra_k_5a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.serviceRow}>
                <div className={gpraStyles.checkbox}>
                  <Checkbox
                    inputId="binary"
                    checked={servicesReceived5?.gpra_k_5a5}
                    onChange={(e) => {
                      removeError("gpra_k_5a1")
                      removeError("gpra_k_5a2")
                      removeError("gpra_k_5a3")
                      removeError("gpra_k_5a4")
                      removeError("gpra_k_5a5")
                      if (e.checked) {
                        updateState(
                          "gpra_k_5a5",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          [
                            { key: "gpra_k_5a1", value: 0 },
                            { key: "gpra_k_5a2", value: 0 },
                            { key: "gpra_k_5a3", value: 0 },
                            { key: "gpra_k_5a4", value: 0 },
                          ]
                        )
                      } else {
                        updateState(
                          "gpra_k_5a5",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          null
                        )
                      }
                    }}
                    disabled={!servicesReceived5?.gpra_k_5}
                    className={validationErrors.gpra_k_5a5 && "p-invalid"}
                  />
                  <label className={gpraStyles.ml1} htmlFor="binary">
                    Client did not receive an FDA-approved medication for an
                    alcohol use disorder
                  </label>
                </div>
                <FormError error={validationErrors.gpra_k_5a5} errorType={2} />
              </div>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "b. Has this client taken the medication as prescribed?"
                  }
                  required
                />
                <Dropdown
                  disabled={
                    disabled ||
                    servicesReceived5?.gpra_k_5a5 ||
                    !servicesReceived5?.gpra_k_5
                  }
                  className={
                    validationErrors.gpra_k_5b
                      ? gpraStyles.input2Error
                      : gpraStyles.input2
                  }
                  value={servicesReceived5?.gpra_k_5b}
                  onChange={(e) => {
                    updateState(
                      "gpra_k_5b",
                      e.value,
                      null,
                      null,
                      servicesReceived5,
                      setServicesReceived5,
                      null
                    )
                  }}
                  options={confirmation}
                  showClear={servicesReceived5?.gpra_k_5b !== undefined}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_k_5b} />
              </div>
            </>
          )}
        </>
      )
    }
    if (question.field === "gpra_k_6") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Has this client previously been diagnosed with a stimulant use disorder?`}
              required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_k_6
                  ? gpraStyles.input2Error
                  : gpraStyles.input2
              }
              value={servicesReceived5?.gpra_k_6}
              onChange={(e) => {
                removeError("gpra_k_6")
                if (!e.value) {
                  updateState(
                    "gpra_k_6",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    [
                      { key: "gpra_k_6a1", value: 0 },
                      { key: "gpra_k_6a2", value: 0 },
                      { key: "gpra_k_6a3", value: 0 },
                      { key: "gpra_k_6a4", value: 0 },
                      { key: "gpra_k_6a5", value: false },
                      { key: "gpra_k_6b", value: false },
                    ]
                  )
                  removeError("gpra_k_6a1")
                  removeError("gpra_k_6a2")
                  removeError("gpra_k_6a3")
                  removeError("gpra_k_6a4")
                  removeError("gpra_k_6a5")
                  removeError("gpra_k_6b")
                } else {
                  updateState(
                    "gpra_k_6",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    null
                  )
                }
              }}
              options={confirmation}
              showClear={servicesReceived5?.gpra_k_6 !== undefined}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_k_6} />
          </div>
          {servicesReceived5?.gpra_k_6 && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "a. In the past 30 days, which evidence-based interventions did the client receive for the treatment of this stimulant use disorder?"
                  }
                  required
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setService={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="1. Contingency Management"
                  number={servicesReceived5?.gpra_k_6a1}
                  setNumber={"gpra_k_6a1"}
                  numberError={validationErrors.gpra_k_6a1}
                  numberErrorType="gpra_k_6a1"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_6 ||
                    servicesReceived5?.gpra_k_6a5
                  }
                  errorsToRemove={[
                    "gpra_k_6a1",
                    "gpra_k_6a2",
                    "gpra_k_6a3",
                    "gpra_k_6a4",
                    "gpra_k_6a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setService={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="2. Community Reinforcement"
                  number={servicesReceived5?.gpra_k_6a2}
                  setNumber={"gpra_k_6a2"}
                  numberError={validationErrors.gpra_k_6a2}
                  numberErrorType="gpra_k_6a2"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_6 ||
                    servicesReceived5?.gpra_k_6a5
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_6a1",
                    "gpra_k_6a2",
                    "gpra_k_6a3",
                    "gpra_k_6a4",
                    "gpra_k_6a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setService={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="3. Cognitive Behavioral Therapy"
                  number={servicesReceived5?.gpra_k_6a3}
                  setNumber={"gpra_k_6a3"}
                  numberError={validationErrors.gpra_k_6a3}
                  numberErrorType="gpra_k_6a3"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_6 ||
                    servicesReceived5?.gpra_k_6a5
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_6a1",
                    "gpra_k_6a2",
                    "gpra_k_6a3",
                    "gpra_k_6a4",
                    "gpra_k_6a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setService={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="4. Other Treatment Approach"
                  number={servicesReceived5?.gpra_k_6a4}
                  setNumber={"gpra_k_6a4"}
                  numberError={validationErrors.gpra_k_6a4}
                  numberErrorType="gpra_k_6a4"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_6 ||
                    servicesReceived5?.gpra_k_6a5
                  }
                  errorsToRemove={[
                    "gpra_k_6a1",
                    "gpra_k_6a2",
                    "gpra_k_6a3",
                    "gpra_k_6a4",
                    "gpra_k_6a5",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.serviceRow}>
                <div className={gpraStyles.checkbox}>
                  <Checkbox
                    inputId="binary"
                    checked={servicesReceived5?.gpra_k_6a5}
                    onChange={(e) => {
                      removeError("gpra_k_6a1")
                      removeError("gpra_k_6a2")
                      removeError("gpra_k_6a3")
                      removeError("gpra_k_6a4")
                      removeError("gpra_k_6a5")
                      if (e.checked) {
                        updateState(
                          "gpra_k_6a5",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          [
                            { key: "gpra_k_6a1", value: 0 },
                            { key: "gpra_k_6a2", value: 0 },
                            { key: "gpra_k_6a3", value: 0 },
                            { key: "gpra_k_6a4", value: 0 },
                          ]
                        )
                      } else {
                        updateState(
                          "gpra_k_6a5",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          null
                        )
                      }
                    }}
                    disabled={!servicesReceived5?.gpra_k_6}
                    className={validationErrors.gpra_k_6a5 && "p-invalid"}
                  />
                  <label className={gpraStyles.ml1} htmlFor="binary">
                    Client did not receive any intervention
                  </label>
                </div>
                <FormError error={validationErrors.gpra_k_6a5} errorType={2} />
              </div>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "b. Has this client attended and participated in evidence-based interventions for stimulant use disorder?"
                  }
                  required
                />
                <Dropdown
                  disabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_6 ||
                    servicesReceived5?.gpra_k_6a5
                  }
                  className={
                    validationErrors.gpra_k_6b
                      ? gpraStyles.input2Error
                      : gpraStyles.input2
                  }
                  value={servicesReceived5?.gpra_k_6b}
                  onChange={(e) => {
                    updateState(
                      "gpra_k_6b",
                      e.value,
                      null,
                      null,
                      servicesReceived5,
                      setServicesReceived5,
                      null
                    )
                  }}
                  options={confirmation}
                  showClear={servicesReceived5?.gpra_k_6b !== undefined}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_k_6b} />
              </div>
            </>
          )}
        </>
      )
    }
    if (question.field === "gpra_k_7") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Has this client previously been diagnosed with a tobacco use disorder?`}
              required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_k_7
                  ? gpraStyles.input2Error
                  : gpraStyles.input2
              }
              value={servicesReceived5?.gpra_k_7}
              onChange={(e) => {
                removeError("gpra_k_7")
                if (!e.value) {
                  updateState(
                    "gpra_k_7",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    [
                      { key: "gpra_k_7a1", value: 0 },
                      { key: "gpra_k_7a2", value: 0 },
                      { key: "gpra_k_7a3", value: 0 },
                      { key: "gpra_k_7a4", value: 0 },
                      { key: "gpra_k_7b", value: false },
                    ]
                  )
                  removeError("gpra_k_7a1")
                  removeError("gpra_k_7a2")
                  removeError("gpra_k_7a3")
                  removeError("gpra_k_7a4")
                  removeError("gpra_k_7b")
                } else {
                  updateState(
                    "gpra_k_7",
                    e.value,
                    null,
                    null,
                    servicesReceived5,
                    setServicesReceived5,
                    null
                  )
                }
              }}
              options={confirmation}
              showClear={servicesReceived5?.gpra_k_7 !== undefined}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_k_7} />
          </div>
          {servicesReceived5?.gpra_k_7 && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "a. In the past 30 days, which FDA-approved medication did the client receive for the treatment of this tobacco use disorder?"
                  }
                  required
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="1. Nicotine Replacement"
                  number={servicesReceived5?.gpra_k_7a1}
                  setNumber={"gpra_k_7a1"}
                  numberError={validationErrors.gpra_k_7a1}
                  numberErrorType="gpra_k_7a1"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_7 ||
                    servicesReceived5?.gpra_k_7a4
                  }
                  errorsToRemove={[
                    "gpra_k_7a1",
                    "gpra_k_7a2",
                    "gpra_k_7a3",
                    "gpra_k_7a4",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="2. Bupropion"
                  number={servicesReceived5?.gpra_k_7a2}
                  setNumber={"gpra_k_7a2"}
                  numberError={validationErrors.gpra_k_7a2}
                  numberErrorType="gpra_k_7a2"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_7 ||
                    servicesReceived5?.gpra_k_7a4
                  }
                  multipleErrors
                  errorsToRemove={[
                    "gpra_k_7a1",
                    "gpra_k_7a2",
                    "gpra_k_7a3",
                    "gpra_k_7a4",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.formRow}>
                <ServicesRow
                  entity={servicesReceived5}
                  setEntity={setServicesReceived5}
                  showDrop={false}
                  removeError={removeError}
                  label="3. Varenicline"
                  number={servicesReceived5?.gpra_k_7a3}
                  setNumber={"gpra_k_7a3"}
                  numberError={validationErrors.gpra_k_7a3}
                  numberErrorType="gpra_k_7a3"
                  summaryDisabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_7 ||
                    servicesReceived5?.gpra_k_7a4
                  }
                  errorsToRemove={[
                    "gpra_k_7a1",
                    "gpra_k_7a2",
                    "gpra_k_7a3",
                    "gpra_k_7a4",
                  ]}
                  defaultZero={question.defaultZero}
                />
              </div>
              <div className={gpraStyles.serviceRow}>
                <div className={gpraStyles.checkbox}>
                  <Checkbox
                    inputId="binary"
                    checked={servicesReceived5?.gpra_k_7a4}
                    onChange={(e) => {
                      removeError("gpra_k_7a1")
                      removeError("gpra_k_7a2")
                      removeError("gpra_k_7a3")
                      removeError("gpra_k_7a4")
                      if (e.checked) {
                        updateState(
                          "gpra_k_7a4",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          [
                            { key: "gpra_k_7a1", value: 0 },
                            { key: "gpra_k_7a2", value: 0 },
                            { key: "gpra_k_7a3", value: 0 },
                          ]
                        )
                      } else {
                        updateState(
                          "gpra_k_7a4",
                          e.checked,
                          null,
                          null,
                          servicesReceived5,
                          setServicesReceived5,
                          null
                        )
                      }
                    }}
                    disabled={!servicesReceived5?.gpra_k_7}
                    className={validationErrors.gpra_k_7a4 && "p-invalid"}
                  />
                  <label className={gpraStyles.ml1} htmlFor="binary">
                    Client did not receive an FDA-approved medication for a
                    tobacco use disorder
                  </label>
                </div>
                <FormError error={validationErrors.gpra_k_7a4} errorType={2} />
              </div>
              <div className={gpraStyles.formRow}>
                <FormLabel
                  label={
                    "b. Has this client taken the medication as prescribed?"
                  }
                  required
                />
                <Dropdown
                  disabled={
                    disabled ||
                    !servicesReceived5?.gpra_k_7 ||
                    servicesReceived5?.gpra_k_7a4
                  }
                  className={
                    validationErrors.gpra_k_7b
                      ? gpraStyles.input2Error
                      : gpraStyles.input2
                  }
                  value={servicesReceived5?.gpra_k_7b}
                  onChange={(e) => {
                    updateState(
                      "gpra_k_7b",
                      e.value,
                      null,
                      null,
                      servicesReceived5,
                      setServicesReceived5,
                      null
                    )
                  }}
                  options={confirmation}
                  showClear={servicesReceived5?.gpra_k_7b}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_k_7b} />
              </div>
            </>
          )}
        </>
      )
    }
  }

  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="K. SERVICES RECEIVED UNDER GRANT FUNDING"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={servicesReceived5}
                    setEntity={setServicesReceived5}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_5}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, servicesReceived5)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={servicesReceived5}
                      setEntity={setServicesReceived5}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_5}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

ServicesReceived5.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

ServicesReceived5.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default ServicesReceived5
